// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__6aSsP","spin":"Loader_spin__IO+td","wrapper":"Loader_wrapper__rImn8","backdrop":"Loader_backdrop__5iqT7","fadeIn":"Loader_fadeIn__303Mk"};